<template>
    <div :class="{ 'modal': true, 'active': showModal }">
        <div class="modal-content">

            <div class="modal-content-header">
                <h3 v-if="category.id">
                    {{ $t('label.editCategory') }}
                </h3>
                <h3 v-else>
                    {{ $t('label.addCategory') }}
                </h3>
                <span class="modal-content-header-close" @click.prevent="close(false)">
	            	<i aria-hidden="true" class="icon icon-close-large"></i>
	            </span>
            </div>

            <div class="modal-content-body">
                <form action="#" class="form" @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">

                            <div class="category-badge">
                                <badge :useTooltip="false" :username="category.name" :backgroundColor="category.color" @badgeClick="toggleColorPicker"></badge>
                                <color-picker-widget v-model="category.color"></color-picker-widget>
                            </div>

                            <div class="category-badge-form margin-top-20">
                                <input-widget
                                        :focused="true"
                                        :placeholder="$t('label.newCategory')"
                                        :type="'text'"
                                        v-model="category.name"
                                        validate="required"
                                        ref="focus">
                                </input-widget>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="button-wrapper-right margin-bottom-20">
                                <input type="submit" :value="$t('button.save')"
                                       :class="{'button-full': true, 'loading': loading}" @click.prevent="validate"/>
                                <span class="button-hollow" @click.prevent="close(false)">{{ $t('button.cancel') }}</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </div>
</template>

<script>
  import InputWidget from '@/components/widgets/InputWidget'
  import Badge from '@/components/widgets/BadgeWidget'
  import ColorPickerWidget from '@/components/widgets/ColorPickerWidget'

  export default {
    name: 'CategoryModal',
    components: {InputWidget, ColorPickerWidget, Badge},
    props: ['data', 'show'],
    data () {
      return {
        showModal: false,
        category: {},
        loading: false
      }
    },
    watch: {
      show (value) {
        this.showModal = value
        if (value) {
          setTimeout(() => {
            this.$refs.focus.$el.querySelector('input').focus()
          }, 500)
        }
      },
      data (value) {
        this.category = value
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true
        if (!this.category.id) {
          this.$api.post('/v1/categories', this.category).then(() => {
            this.close(true)
            this.$events.fire('message-open', {
              type: 'success',
              message: this.$t('message.saveSuccess')
            })
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        } else {
          this.$api.post('/v1/categories/' + this.category.id, this.category).then(() => {
            this.close(true)
            this.$events.fire('message-open', {
              type: 'success',
              message: this.$t('message.saveSuccess')
            })
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        }
      },
      toggleColorPicker () {
        this.$events.fire('colorpicker-toggle')
      },
      close (updated) {
        this.showModal = false
        this.category = {}
        this.$emit('closed', {
          show: this.showModal,
          updated: updated
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/Categories/CategoryModal.vue